import React, { Dispatch, SetStateAction, useState } from "react";
import { Close } from "@mui/icons-material";
import TurnLeftIcon from "@mui/icons-material/TurnLeft";
// import TurnRightIcon from "@mui/icons-material/TurnRight";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { quillModules } from "src/pages/mail-box/EmailDetails";
import ReactQuill from "react-quill";
import {
  Typography,
  Button,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import {
  GetAllEmails,
  SendEmail,
  setCurrentEmail,
} from "src/redux/features/mailBox/mailbox-slice";
import "../../mail-box/emailEditor.scss";
import EmailContent from "src/pages/mail-box/EmailContent";

interface IEmailViewModalProps {
  setOpenEmailView: Dispatch<SetStateAction<boolean>>;
}

const EmailViewModal: React.FC<IEmailViewModalProps> = ({
  setOpenEmailView,
}) => {
  const dispatch = useAppDispatch();
  const [reply, setReply] = useState<boolean>(false);
  const [emailBody, setEmailBody] = useState("");
  const [attachments, setAttachments] = useState<File[]>([]);
  const {
    currentEmail,
    isLoading,
    isThreadsLoading,
    mailBoxAuthData,
    threads,
  } = useAppSelector((state) => state.mailBoxSlice);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setAttachments([...attachments, ...Array.from(event.target.files)]);
    }
  };

  const removeAttachment = (index: number) => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };

  const handleReplyEmail = async () => {
    if (!mailBoxAuthData) {
      return;
    }
    setReply(false);
    await dispatch(
      SendEmail({
        email: mailBoxAuthData.email,
        subject: `Re: ${currentEmail?.subject}`,
        body: emailBody,
        to: [currentEmail?.from[0].email ?? ""],
        attachments,
        replyTo: currentEmail?.from[0].email,
        messageId: currentEmail?.id,
      })
    );
    //get updated threads
    dispatch(
      GetAllEmails({
        userEmail: mailBoxAuthData.email,
        pageToken: "",
        threadId: currentEmail?.threadId,
      })
    );
    setEmailBody("");
  };

  if (isLoading || isThreadsLoading) {
    return (
      <Box className="customLoader">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="emailView-modal">
      <Box className="largeModel__head">
        <Typography variant="h5" className="largeModel__title emailSubject">
          {currentEmail?.subject}
        </Typography>
        <Button
          className="largeModel__closeBtn"
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            setOpenEmailView(false);
            dispatch(setCurrentEmail(null));
          }}
        >
          <Close />
        </Button>
      </Box>
      <Box className="largeModel__body emailDetails emailView-body">
        <EmailContent
          mailData={currentEmail}
          mailBoxAuthData={mailBoxAuthData}
        />
        {/* thread replies */}
        <div className="emails-Threads">
          {threads
            .filter((item) => item.id !== currentEmail?.id)
            .map((item) => (
              <div className="thread">
                <EmailContent
                  mailData={item}
                  mailBoxAuthData={mailBoxAuthData}
                />
              </div>
            ))}
        </div>

        {/* <div ref={bottomRef} /> */}
        {reply && (
          <Box className="email-Editor">
            <ReactQuill
              value={emailBody}
              onChange={setEmailBody}
              modules={quillModules}
              placeholder="Compose your email..."
            />
            <Box className="email-attachments">
              {attachments.map((file, index) => (
                <Box key={index} className="email-attachment">
                  <Typography variant="body2" className="attachment-name">
                    {file.name}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => removeAttachment(index)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </Box>
            {/* Attachment Section */}
          </Box>
        )}
      </Box>

      {/* <Box className="largeModel__footer"> */}
      {!reply && (
        <div className="emailView-modal-footer">
          <Button
            variant="contained"
            onClick={() => {
              setReply(true);
            }}
          >
            <TurnLeftIcon />
            Reply
          </Button>
          {/* <Button variant="outlined">
            <TurnRightIcon />
            Forward
          </Button> */}
        </div>
      )}

      {reply && (
        <div className="emailView-modal-footer">
          <div className="flex-gap">
            <Button
              variant="contained"
              color="primary"
              onClick={handleReplyEmail}
            >
              Send
            </Button>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="file-upload"
            />
            <label htmlFor="file-upload">
              <IconButton color="primary" component="span">
                <AttachFileIcon />
              </IconButton>
            </label>
          </div>
          <DeleteOutlinedIcon
            color="action"
            className="icon"
            onClick={() => {
              setEmailBody("");
              setReply(false);
            }}
          />
        </div>
      )}
      {/* </Box> */}
    </div>
  );
};

export default EmailViewModal;
